<div *ngIf="!hasCookie" class="cookie-banner shadow-up bg-primary">
	<div class="container">
		<div class="p-2 p-md-3 d-flex align-items-center">
			<div class="mb-1 text-white pr-4">This site uses cookies to provide you with the best onsite experience. Read our <a href="/privacy" class="btn btn-link inline text-white p-0 m-0 text-decoration-underline">privacy policy</a> to <span class="no-break">learn more.</span></div>
			<div class="btn btn-light pill font-family-accent font-weight-bold text-primary d-block d-md-inline-block px-4" (click)="closeCookieBanner()">OK</div>
		</div>
	</div>
</div>